import { IconName } from '../Icon/Icon.types';

export enum StepStatus {
    Inactive = 'inactive',
    Pending = 'pending',
    Done = 'done',
    Error = 'error',
}

export type Step = {
    text: string;
    icon?: IconName;
    iconColor?: string;
    status: StepStatus;

    // Если есть to, то отрендерится Link, иначе кнопка с onClick
    to?: string;
    onClick?: () => void;
};

export type StepsProps = {
    steps: Step[];
};
